import { Block } from '@mote/ui/components'
import { useOnboarding } from '../context'
import { Hint } from './Hint'

export interface SchoolHintsProps {
  selectedHint: string
  onHintSelection: (hint: string) => void
}

export const SchoolHints = (props: SchoolHintsProps) => {
  const onboarding = useOnboarding()
  const hints = onboarding.institutionNameHints.filter(
    hint => hint !== props.selectedHint
  )

  if (hints.length === 0) return null

  return (
    <Block layout='horizontal' align='center' gap={8} wrapped>
      {hints.map((hint, index) => {
        return (
          <Hint
            key={`${hint}-${index}`}
            text={hint}
            onClick={() => props.onHintSelection(hint)}
          />
        )
      })}
    </Block>
  )
}
